import styled, { keyframes, css } from 'styled-components'
import { ScrollableTable } from '../Table/Table'

const spin = keyframes`
    to { transform: rotate(360deg); }
`

const fadeInOverlay = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`
export const LoadingOverlay = styled.div`
    animation: ${fadeInOverlay} 0.2s ease-out forwards;
    animation-delay: 0.05s;
    position: absolute; 
    inset: 0;
    background-color: rgba(240, 240, 240, 0.3);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;

    &::after {
        content: '';
        width: 3em;
        height: 3em;
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-top-color: #FFD249;
        border-radius: 50%;
        animation: ${spin} 0.8s linear infinite;
    }
`

const fadeInTable = keyframes`
    from { opacity: 1; }
    to { opacity: 0.2; }
`

export const StyledScrollableTable = styled(ScrollableTable)<{ isLoading?: boolean }>`
    ${({ isLoading: $isLoading }) => $isLoading && css`animation: ${fadeInTable} 0.35s ease-out forwards;`}
    overflow: visible;
`
